/**
 * LERA Information Bar — Sprint S9.2.1
 * Premium vertical fade. Marquee remains CSS-only.
 */

(function () {
  const ROOT = '[data-lera-ib]';
  const REDUCED = '(prefers-reduced-motion: reduce)';
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function prefersReducedMotion() {
    return window.matchMedia(REDUCED).matches;
  }

  class LeraInformationBarFade {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-lera-ib-fade]');
      if (!this.stage) return;

      this.slides = [...this.stage.querySelectorAll('[data-lera-ib-slide]')];
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      if (this.index < 0) this.index = 0;

      this.messageMs = Math.min(
        10000,
        Math.max(2000, Number(this.stage.dataset.leraIbInterval || 5) * 1000)
      );
      this.transitionMs = Math.min(
        800,
        Math.max(200, Number(this.stage.dataset.leraIbTransition || 500))
      );
      this.timer = null;
      this.busy = false;

      this.stage.style.setProperty('--lera-ib-fade-ms', `${this.transitionMs}ms`);
      this.stage.style.setProperty('--lera-ib-fade-ease', EASING);

      if (this.slides.length < 2 || prefersReducedMotion()) {
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.classList.remove('is-leaving', 'is-entering');
        });
        return;
      }

      this.start();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.messageMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (this.busy || this.slides.length < 2) return;
      this.busy = true;

      const current = this.slides[this.index];
      const nextIndex = (this.index + 1) % this.slides.length;
      const next = this.slides[nextIndex];

      current.classList.remove('is-entering');
      current.classList.add('is-leaving');
      current.classList.remove('is-active');

      next.classList.remove('is-leaving');
      next.classList.add('is-entering');
      void next.offsetWidth;
      next.classList.remove('is-entering');
      next.classList.add('is-active');

      this.index = nextIndex;

      window.setTimeout(() => {
        current.classList.remove('is-leaving');
        this.busy = false;
      }, this.transitionMs + 20);
    }

    destroy() {
      this.stop();
      this.busy = false;
    }
  }

  function boot(scope) {
    const roots = (scope || document).querySelectorAll(ROOT);
    roots.forEach((root) => {
      if (root._leraIbFade) {
        root._leraIbFade.destroy();
        root._leraIbFade = null;
      }
      if (root.dataset.leraIbMode === 'fade') {
        root._leraIbFade = new LeraInformationBarFade(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT).forEach((root) => {
      root._leraIbFade?.destroy();
    });
  });

  window.LeraInformationBar = { version: '9.2.1', refresh: boot };
})();
